import { render, staticRenderFns } from "./Fade.vue?vue&type=template&id=134d2169&scoped=true"
import script from "./Fade.vue?vue&type=script&lang=js"
export * from "./Fade.vue?vue&type=script&lang=js"
import style0 from "./Fade.vue?vue&type=style&index=0&id=134d2169&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d2169",
  null
  
)

export default component.exports